exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-dialog__content--active[data-v-5ef97dbc]{z-index:99999!important}", ""]);

// exports
